import React from 'react';
import { Navbar } from 'react-bootstrap';
import { Link, IndexLink } from 'react-router';


class ProductSubEdit extends React.Component {

   render() {
      const { productId } = this.props.params;
      return (
         <div>
            <Navbar>
               <ul className="nav navbar-nav" >
                  <li>
                     <IndexLink to={`/product/productSub/edit/${productId}`} activeStyle={{ color: 'red' }} >General
                     </IndexLink>
                  </li>
                  <li>
                     <Link to={`/product/productSub/edit/${productId}/feature`}
                           activeStyle={{ color: 'red' }} >Features</Link>
                  </li>
                  <li>
                     <Link to={`/product/productSub/edit/${productId}/image`}
                           activeStyle={{ color: 'red' }} >Images</Link>
                  </li>
               </ul>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}
ProductSubEdit.propTypes = {
   children: React.PropTypes.object,
   params: React.PropTypes.object
};

export default ProductSubEdit;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductSub/ProductSubEdit/ProductSubEdit.js
 **/